import { Box } from "@mui/material"
import { SUPPORTED_ATTACHMENT_MIME_TYPES } from "src/services/api/chat/attachments"
import { AttachmentCard } from "../AttachmentCard"
import { IChatMessageAttachment } from "./types"

interface IMessageAttachmentsProps {
    attachments: IChatMessageAttachment[]
}

/** Same mime_type → label lookup the pre-send preview uses; falls back to the filename's extension
 * for cases where mime_type isn't available (e.g. older history entries) or isn't in that map. */
const fileTypeLabel = (attachment: IChatMessageAttachment): string => {
    if (attachment.mime_type && attachment.mime_type in SUPPORTED_ATTACHMENT_MIME_TYPES) {
        return SUPPORTED_ATTACHMENT_MIME_TYPES[attachment.mime_type]
    }
    const parts = attachment.filename.split(".")
    return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : ""
}

const MessageAttachments = ({ attachments }: IMessageAttachmentsProps) => (
    <Box className="chat-attachments">
        {attachments.map((attachment, index) => (
            <AttachmentCard
                key={`${attachment.filename}-${index}`}
                filename={attachment.filename}
                typeLabel={fileTypeLabel(attachment)}
                sizeBytes={attachment.sizeBytes}
            />
        ))}
    </Box>
)

export { MessageAttachments }
